import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import { updatepageHeader, resetpageHeader } from "../../redux/pageHeaderSlice";
import {
  updateShowFields,
  updateShowFieldsByIndex,
  emptyShowFields,
  addDisableToParams,
} from "../../redux/showFieldsSlice";
import {
  updaterelatedFields,
  resetrelatedFields,
  updateRelatedFieldsByParam,
} from "../../redux/relatedFieldsSlice";
import { setShowPopupFalse, updatenavPopup } from "../../redux/navPopupSlice";
import DynamicList from "../../components/DynamicList/DynamicList";
import EnhancedDynamicList from "../../components/DynamicList/EnhancedDynamicList";
import ReusableForm from "../../components/ReusableForm/ReusableForm";
import { PropagateLoader } from "react-spinners";

import {
  addDefaultValuesToFields,
  extractFiles,
  extractFromObject,
  findDataInObject,
  getDifferingValues,
  getObjectParamsWithSubstring,
  hasFileInput,
} from "../../utils/helperFuctions";
import { config, offsetNumber } from "../../utils/config";
import PopUp from "../../components/PopUp/PopUp";
import { resetAuthentication } from "../../redux/authenticationSlice";
import { getCookie, setCookie } from "../../utils/cookieHandler";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";
import {
  resetSavePopup,
  updateSavePopupToTrue,
} from "../../redux/savePopupSlice";
import { useNavigate, useSearchParams } from "react-router-dom";

const fieldMapping = {
  primary_currency: "primary_currency.id",
  secondary_currency: "secondary_currency.id",
  branch: "branch.id",
  brand: "brand.id",
  category: "category.id",
  season: "season.id",
  currency: "currency.id",
  vehicle_class: "vehicle_class.id",
  class: "class.id",
  model: "model.id",
  type: "type.id",
  location: "location.id",
  color: "color.id",
  company: "company.id",
  addon: "addon.id",
  pickup_fleet_location: "pickup_fleet_location.id",
  return_fleet_location: "return_fleet_location.id",
  contact: "contact.id",
  manager: "manager.id",
  method: "method.id",
  mileage_option: "mileage_option.id",
  coverage_option: "coverage_option.id",
  additional_driver_addon: "additional_driver_addon.id",
  role: "role.id",
};

const ListFormTemplate = ({
  apiRoute,
  columns,
  fields,
  bringFormData,
  tabsData,
  onlyForm,
  createRoles,
  deleteRoles,
  editRoles,
  tableNameInDb,
  bulkActions, // Optional bulk actions configuration
  hasImport = false, // Enable import button
  importConfig = null, // Import configuration { relationshipMappings: [] }
  enhancedTable = true, // Default to overhauled table UI & customization
}) => {
  const editFields = useSelector((state) => state.showFields);

  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const relatedFields = useSelector((state) => state.relatedFields);
  const navPopup = useSelector((state) => state.navPopup);
  const dispatch = useDispatch();
  //const pageFields =  [ ...fields];

  //dispatch(updatepageHeader({ ...pageHeader, addButton: true }))

  const currentRole = getCookie("_r");

  function waitForCookie(name) {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const value = getCookie(name);
        if (value) {
          clearInterval(interval);
          resolve(value);
        }
      }, 50);
    });
  }
  // //Roles
  // const captain = process.env.REACT_APP_CAPTAIN_ID;
  // const admin = process.env.REACT_APP_ADMIN_ROLE;

  const [data, setData] = useState([]);
  const [reservationCode, setReservationCode] = useState(null);
  const [addNew, setAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  //const [editFields, setEditFields] = useState(fields);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [popupData, setpopupData] = useState({});
  const buttonClicked = async (e) => {
    setLoading(true);
    setEdit(false);
    setEditId(null);
    setReservationCode(null);
    setAddNew(true);
    if (bringFormData instanceof Function) await bringFormData();
    setLoading(false);
    navigate("?", { replace: true });
    //dispatch(updateShowFields(fields))
  };
  const sanitizeField = (field) => {
    const sanitizedField = { ...field };
    Object.keys(sanitizedField).forEach((key) => {
      const value = sanitizedField[key];
      if (value && typeof value === "object" && value.$$typeof) {
        delete sanitizedField[key]; // Remove React elements or symbols
      }
    });
    return sanitizedField;
  };
  useEffect(() => {
    if (!(edit && editId)) {
      //Check if there are initConditions
      dispatch(updateShowFields(fields));
    } else {
      const newFields = fields.map((f, i) => {
        return { ...f, ...editFields[i] };
      });
      dispatch(updateShowFields(newFields));
    }
  }, [fields]);
  const resetPopUp = () => {
    setpopupData({});
  };
  const formDataChanged = useCallback((data, name, updateRelated) => {
    dispatch(updateSavePopupToTrue());
    if (navPopup.trigger !== true) {
      dispatch(updatenavPopup({ trigger: edit }));
    }
    if (
      data &&
      Array.isArray(editFields) &&
      name /*&& (data[name] || data[name] === 0)*/
    ) {
      var tempfields = [...editFields];
      var toChangeIndex = tempfields.findIndex((x) => x.name === name);

      if (toChangeIndex !== -1) {
        tempfields[toChangeIndex] = {
          ...tempfields[toChangeIndex],
          defaultValue: data[name],
          changed: true,
        };

        dispatch(
          updateShowFieldsByIndex({
            index: toChangeIndex,
            toChange: sanitizeField(tempfields[toChangeIndex]),
          })
        );
        if (updateRelated) {
          let temp = { ...relatedFields };
          temp[name] = data[name];
          dispatch(updaterelatedFields(temp));
        }
      }
    }
  }, [edit, editFields, navPopup.trigger, relatedFields, dispatch]);
  const deleteClicked = async (id) => {
    //const id = e.target?.name;

    const deleteData = async () => {
      try {
        setLoading(true);
        const resp = await axios.delete(
          config.apiUrl + "/api/" + apiRoute + "/" + id,
          { headers: { Authorization: `Bearer ${getCookie("_AT")}` } }
        );
        if (resp.headers?.authorization) {
          if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
            setCookie("_AT", resp.headers.authorization.split(" ")[1]);
          }
        }
        if (resp.status >= 200 && resp.status <= 299) {
          getData();
        } else {
          setpopupData({
            isError: true,
            title: "An Error Occured",
            description: "Error deleting data",
            showPopUp: true,
            hideCancel: true,
          });
          setLoading(false);
        }
      } catch (error) {
        setpopupData({
          isError: true,
          title: "An Error Occured",
          description: error.response?.data?.error?.message || error.message,
          showPopUp: true,
          hideCancel: true,
        });
        setLoading(false);
      }
    };
    if (id) {
      setpopupData({
        title: "Deleting data",
        description: "Are you sure you want to delete?",
        takeActionText: "Delete",
        takeActionFun: deleteData,
        showPopUp: true,
      });
    }
  };
  const duplicateClicked = async (id) => {
    //const id = e.target?.name;

    const duplicateData = async () => {
      try {
        setLoading(true);
        const resp = await axios.post(
          config.apiUrl + "/api/" + apiRoute + "/duplicate/" + id,
          {},
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          }
        );
        if (resp.headers?.authorization) {
          if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
            setCookie("_AT", resp.headers.authorization.split(" ")[1]);
          }
        }
        if (resp.status >= 200 && resp.status <= 299) {
          getData();
        } else {
          setpopupData({
            isError: true,
            title: "An Error Occured",
            description: "Error duplicating data",
            showPopUp: true,
            hideCancel: true,
          });
          setLoading(false);
        }
      } catch (error) {
        setpopupData({
          isError: true,
          title: "An Error Occured",
          description: error.message,
          showPopUp: true,
          hideCancel: true,
        });
        setLoading(false);
      }
    };
    if (id) {
      setpopupData({
        title: "Duplicating data",
        description: `Are you sure you want to duplicate id:${id} ? `,
        takeActionText: "Duplicate",
        takeActionFun: duplicateData,
        showPopUp: true,
      });
    }
  };
  const refreshAllcardFields = async (id) => {
    const resp = await axios
      .get(config.apiUrl + "/api/" + apiRoute + "/" + id, {
        headers: { Authorization: `Bearer ${getCookie("_AT")}` },
      })
      .catch((e) => {
        console.log(e.message);
      });
    if (resp) {
      if (resp.headers?.authorization) {
        if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
          setCookie("_AT", resp.headers.authorization.split(" ")[1]);
        }
      }
      var tempfields = { ...resp.data };

      for (const [field, propertyPath] of Object.entries(fieldMapping)) {
        const propertyPathArray = propertyPath.split(".");
        let value = resp.data;

        for (const prop of propertyPathArray) {
          if (value && value[prop]) {
            value = value[prop];
          } else {
            value = undefined;
            break;
          }
        }

        if (value !== undefined) {
          tempfields = { ...tempfields, [field]: value };
        }
      }
      const toUpdate = addDefaultValuesToFields(fields, tempfields);

      dispatch(updateShowFields(toUpdate));
      setEditId(id);
      setEdit(true);
      setpopupData({
        showPopUp: false,
      });
    }
  };
  // const editClicked = async (e) => {
  //   const id = e.target?.name;
  //   if (id) {
  //     setLoading(true);

  //     const resp = await axios
  //       .get(config.apiUrl + "/api/" + apiRoute + "/" + id, {
  //         headers: { Authorization: `Bearer ${getCookie("_AT")}` },
  //       })
  //       .catch((e) => {
  //       });
  //     if (resp) {
  //       if (resp.headers?.authorization) {
  //         if (`Bearer ${getCookie("_AT")}` !== resp.headers.authorization) {
  //           setCookie("_AT", resp.headers.authorization.split(" ")[1]);
  //         }
  //       }
  //       if (
  //         resp.data != null &&
  //         resp.data.reservation_code != null &&
  //         resp.data.status != null
  //       ) {
  //         setReservationCode(resp.data.reservation_code);
  //       }
  //       setAddNew(true);
  //       setEditId(id);
  //       setEdit(true);
  //       if (bringFormData instanceof Function) await bringFormData();

  //       var tempfields = { ...resp.data };

  //       for (const [field, propertyPath] of Object.entries(fieldMapping)) {
  //         const propertyPathArray = propertyPath.split(".");
  //         let value = resp.data;

  //         for (const prop of propertyPathArray) {
  //           if (value && value[prop]) {
  //             value = value[prop];
  //           } else {
  //             value = undefined;
  //             break;
  //           }
  //         }

  //         if (value !== undefined) {
  //           tempfields = { ...tempfields, [field]: value };
  //         }
  //       }
  //       setLoading(false);

  //       const toUpdate = addDefaultValuesToFields(fields, tempfields);

  //       dispatch(updateShowFields(toUpdate));
  //       //setEditFields(()=> addDefaultValuesToFields(fields,tempfields));
  //     }

  //   }
  //   //setAddNew(true)
  // };

  const getData = async () => {
    const _r = await waitForCookie("_r");
    let page = Number(searchParams.get("page"));
    let sortBy = searchParams.get("sortBy");
    let sortDirection = searchParams.get("sortDirection");
    let q = searchParams.get("q");
    let activeFilters = searchParams.get("activeFilters");
    let filterOperator = searchParams.get("filterOperator");
    let isRelation = searchParams.get("isRelation");
    let sortingRelationSubValue = searchParams.get("sortingRelationSubValue");
    let sortingRelationWhereField = searchParams.get("sortingRelationWhereField");
    let sortingRelationWhereValue = searchParams.get("sortingRelationWhereValue");
    let query = `?currentRole=${_r}`;
    if (page != null) {
      if (q != null && q.trim() !== "") {
        query += `&page=${1}`;
      } else {
        query += `&page=${page || 1}`;
      }
    }
    if (sortBy != null) {
      query += `&sortBy=${sortBy}`;
    }
    if (sortDirection != null) {
      query += `&sortDirection=${sortDirection}`;
    }
    if (q != null && q.trim() !== "") {
      query += `&q=${q}`;
    }
    if (activeFilters != null) {
      query += `&activeFilters=${activeFilters}`;
    }
    if (filterOperator != null) {
      query += `&filterOperator=${filterOperator}`;
    }
    if (isRelation != null) {
      query += `&isRelation=${isRelation}`;
    }
    if (sortingRelationSubValue != null) {
      query += `&sortingRelationSubValue=${sortingRelationSubValue}`;
    }
    if (sortingRelationWhereField != null && sortingRelationWhereValue != null) {
      query += `&sortingRelationWhereField=${sortingRelationWhereField}&sortingRelationWhereValue=${sortingRelationWhereValue}`;
    }
    dispatch(resetrelatedFields());
    axios
      .get(config.apiUrl + "/api/" + apiRoute + query, {
        headers: {
          Authorization: `Bearer ${getCookie("_AT")}`,
        },
      })
      .then((response) => {
        if (response?.headers?.authorization) {
          if (`Bearer ${getCookie("_AT")}` !== response.headers.authorization) {
            setCookie("_AT", response.headers.authorization.split(" ")[1]);
          }
        }
        if (response.data && response.data?.data.length > 0) {
          setData(response.data);
        } else {
          setData([]);
        }
        setLoading(false);
      })
      .catch((error) => {
        // Handle errors
        if (error.response?.status !== 401) {
          setpopupData({
            isError: true,
            title: "An Error Occured",
            description: error.response?.data?.error?.message || error.message,
            showPopUp: true,
            hideCancel: true,
          });
        } else {
          dispatch(resetAuthentication());
        }
        setLoading(false);
      });
  };

  const callPopUp = (data) => {
    setpopupData({
      isError: data.isError,
      title: data.title,
      description: data.description,
      showPopUp: true,
      hideCancel: data.hideCancel,
      children: data.children,
    });
  };

  useEffect(() => {
    //dispatch(updatepageHeader({ ...pageHeader, addButton: true, buttonText: "Add New", buttonFunction: buttonClicked }));
    if (!addNew) {
      getData();
    }
    //dispatch(updateShowFields(pageFields))
    // if (onlyForm?.id) {
    //   const e = {
    //     target: {
    //       name: onlyForm.id,
    //     },
    //   };

    //   editClicked(e);
    // }
    return () => {
      dispatch(resetpageHeader());
    };
  }, []);

  const backClicked = async () => {
    getData();
    setAddNew(false);
    dispatch(resetrelatedFields());
  };

  useEffect(() => {
    if (loading) {
      dispatch(updatepageHeader({ addButton: false }));
    } else {
      if (addNew) {
        dispatch(
          updatepageHeader({
            addButton: true,
            buttonText: onlyForm ? (
              ""
            ) : (
              <>
                <ArrowLeftIcon className="w-5 inline-block" />
                <span>Exit</span>
              </>
            ),
            buttonFunction: onFormCancel,
          })
        );
      } else {
        if (createRoles?.includes(currentRole)) {
          dispatch(
            updatepageHeader({
              secondaryButton: false,
              addButton: true,
              buttonText: "Add New",
              buttonFunction: buttonClicked,
              sequenceButton: false,
              sequenceButtonProps: null,
            })
          );
        } else {
          dispatch(
            updatepageHeader({
              secondaryButton: false,
              addButton: false,
              buttonText: "",
              buttonFunction: () => { },
              sequenceButton: false,
              sequenceButtonProps: null,
            })
          );
        }
      }
    }
  }, [loading, addNew]);

  // const navigtePopup = () => {
  //   dispatch(
  //     updatenavPopup({
  //       navigate: true,
  //       showPopup: false,
  //       trigger: false,
  //       backClicked: false,
  //     })
  //   );
  //   // resetPopUp();
  // };

  // useEffect(() => {
  //   //showPopup

  //   if (navPopup.backClicked) {
  //     if (navPopup.showPopup) {
  //       setpopupData({
  //         isError: true,
  //         title: "Are you sure you want to exit?",
  //         description: "You might lose unsaved changes.",
  //         showPopUp: true,
  //         takeActionText: "Yes",
  //         takeActionFun: finalizeCancel,
  //       });
  //     } else {
  //       finalizeCancel();
  //     }
  //   }
  // }, [navPopup]);

  const handleSubmit = async (__formData_, hasFiles, stay) => {
    // Handle form submission here
    const handleSubmitLogic = async () => {
      const __formData = { ...__formData_, ...relatedFields };

      dispatch(resetrelatedFields());
      dispatch(setShowPopupFalse());
      dispatch(resetSavePopup());
      setpopupData({
        title: "Saving data...",
        showPopUp: true,
        hideCancel: true,
        hideMainButton: true,
        showLoading: true,
      });
      let filesToUpload;
      //const formDataToSend = new FormData();

      if (hasFiles) {
        // Append all fields and files to the FormData object
        filesToUpload = extractFiles(__formData, editFields);

        //processFormData(formDataToSend,__formData)
      }
      const _formData = __formData; // hasFiles ? formDataToSend : __formData;

      if (edit === true) {
        const editValues = getDifferingValues(editFields, _formData, false);

        try {
          const response = await axios
            .put(
              config.apiUrl + "/api/" + apiRoute + "/" + editId,
              editValues,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getCookie("_AT")}`,
                },
              }
            )
            .catch((e) => {
              console.log(e);
              setpopupData({
                isError: true,
                title: "An Error Occured",
                description: e.response?.data?.error?.message || e.message,
                showPopUp: true,
                hideCancel: true,
              });
              if (!onlyForm?.id && !stay) {
                setEdit(false);
                setAddNew(false);
              }
            });

          if (response === undefined) {
            return null;
          }

          if (response.headers?.authorization) {
            if (
              `Bearer ${getCookie("_AT")}` !== response.headers.authorization
            ) {
              setCookie("_AT", response.headers.authorization.split(" ")[1]);
            }
          }
          if (response.data?.error) {
            setpopupData({
              isError: true,
              title: "An Error Occured",
              description: response.data.error.message,
              showPopUp: true,
              hideCancel: true,
            });
            if (!onlyForm?.id && !stay) {
              setEdit(false);
              setAddNew(false);
            }
          } else {
            if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
              for (const fileToUpload of filesToUpload) {
                console.log("uploading...");

                const fileToUploadValue = fileToUpload.value;
                const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                const totalChunks = Math.ceil(
                  fileToUploadValue.size / chunkSize
                );
                const chunkProgress = 100 / totalChunks;
                let chunkNumber = 0;
                let start = 0;
                let end = 0;
                setpopupData({
                  title: "Uploading",
                  description: fileToUploadValue.name,
                  showPopUp: true,
                  hideCancel: true,
                  hideMainButton: true,
                  showLoading: true,
                  progressValue: 0,
                });

                const uploadNextChunk = async () => {
                  if (end <= fileToUploadValue.size) {
                    start = end;
                    end = start + chunkSize;
                    const chunk = fileToUploadValue.slice(start, end);
                    const fd = new FormData();
                    fd.append("file", chunk);
                    fd.append("chunkNumber", chunkNumber);
                    fd.append("totalChunks", totalChunks);
                    fd.append("originalname", fileToUploadValue.name);
                    fd.append("type", fileToUploadValue.type);
                    fd.append("size", fileToUploadValue.size);
                    fd.append("param", fileToUpload.param || "");
                    fd.append("isMulti", fileToUpload.isMulti || false);
                    fd.append(
                      "childRelated",
                      fileToUpload.childRelated || false
                    );
                    fd.append("childRelatedId", fileToUpload.childRelatedId);

                    const ufResp = await axios.post(
                      config.apiUrl + "/api/" + apiRoute + "/upload/" + editId,
                      fd,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    );
                    setpopupData({
                      title: "Uploading",
                      description: fileToUploadValue.name,
                      showPopUp: true,
                      hideCancel: true,
                      hideMainButton: true,
                      showLoading: true,
                      progressValue: Number((chunkNumber + 1) * chunkProgress),
                    });
                    chunkNumber++;

                    await uploadNextChunk();
                  }
                };

                await uploadNextChunk();
              }
            }

            dispatch(
              updatenavPopup({
                showPopup: false,
                trigger: false,
                backClicked: false,
              })
            );
            if (!onlyForm?.id) {
              if (!stay) {
                setpopupData({
                  showPopUp: false,
                });
                getData();
                setEdit(false);
                setAddNew(false);
              } else {
                refreshAllcardFields(response.data?.id);
              }
            } else {
              refreshAllcardFields(response.data?.id);
            }
          }

          return response.data;
        } catch (error) {
          if (error.response?.status !== 401) {
            setpopupData({
              isError: true,
              title: "Error submitting form",
              description:
                error.response?.data?.error?.message || error.message,
              showPopUp: true,
              hideCancel: true,
            });
          } else {
            dispatch(resetAuthentication());
          }
          console.error(error);

          if (!onlyForm?.id && !stay) {
            setEdit(false);
            setAddNew(false);
          }
        }
      } else {
        try {
          const response = await axios
            .post(config.apiUrl + "/api/" + apiRoute + "/add", _formData, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("_AT")}`,
              },
            })
            .catch((error) => {
              console.log(error);
              if (error.response?.status !== 401) {
                setpopupData({
                  isError: true,
                  title: "Error submitting form",
                  description:
                    error.response?.data?.error?.message || error.message,
                  showPopUp: true,
                  hideCancel: true,
                });
              } else {
                dispatch(resetAuthentication());
              }
              if (!onlyForm?.id && !stay) {
                setEdit(false);
                setAddNew(false);
              }
            });

          if (response === undefined) {
            return null;
          }

          if (response.headers?.authorization) {
            if (
              `Bearer ${getCookie("_AT")}` !== response.headers.authorization
            ) {
              setCookie("_AT", response.headers.authorization.split(" ")[1]);
            }
          }

          if (response.data?.error) {
            setpopupData({
              isError: true,
              title: "Error submitting form",
              description: response.data.error.message,
              showPopUp: true,
              hideCancel: true,
            });
            if (!stay) {
              setAddNew(false);
            }
          } else {
            if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
              for (const fileToUpload of filesToUpload) {
                const fileToUploadValue = fileToUpload.value;
                const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                const totalChunks = Math.ceil(
                  fileToUploadValue.size / chunkSize
                );
                const chunkProgress = 100 / totalChunks;
                let chunkNumber = 0;
                let start = 0;
                let end = 0;
                setpopupData({
                  title: "Uploading",
                  description: fileToUploadValue.name,
                  showPopUp: true,
                  hideCancel: true,
                  hideMainButton: true,
                  showLoading: true,
                  progressValue: 0,
                });

                const uploadNextChunk = async () => {
                  if (end <= fileToUploadValue.size) {
                    start = end;
                    end = start + chunkSize;
                    const chunk = fileToUploadValue.slice(start, end);
                    const fd = new FormData();
                    fd.append("file", chunk);
                    fd.append("chunkNumber", chunkNumber);
                    fd.append("totalChunks", totalChunks);
                    fd.append("originalname", fileToUploadValue.name);
                    fd.append("type", fileToUploadValue.type);
                    fd.append("size", fileToUploadValue.size);
                    fd.append("param", fileToUpload.param || "");
                    fd.append("isMulti", fileToUpload.isMulti || false);
                    const ufResp = await axios.post(
                      config.apiUrl +
                      "/api/" +
                      apiRoute +
                      "/upload/" +
                      response.data?.id,
                      fd,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    );
                    setpopupData({
                      title: "Uploading",
                      description: fileToUploadValue.name,
                      showPopUp: true,
                      hideCancel: true,
                      hideMainButton: true,
                      showLoading: true,
                      progressValue: Number((chunkNumber + 1) * chunkProgress),
                    });
                    chunkNumber++;

                    await uploadNextChunk();
                  }
                };

                await uploadNextChunk();
              }
            }

            if (!stay) {
              getData();
              setAddNew(false);
              setpopupData({
                showPopUp: false,
              });
            } else {
              if (response.data?.id != null) {
                navigate(
                  `/${window.location.href.split("/").reverse()[0]}/${response.data?.id
                  }`
                );
              }
              refreshAllcardFields(response.data?.id);
              // setEdit(true);
              // setEditId(response.data?.id);

              // const relatedCards = editFields.filter( x => x.type === "card" && Array.isArray(x.defaultValue))

              // if(relatedCards){
              //   for (const field of relatedCards) {
              //     if(response.data[field.name]){
              //     }
              //   }
              // }
            }
          }

          return response.data;
        } catch (error) {
          if (error.response?.status !== 401) {
            setpopupData({
              isError: true,
              title: "Error submitting form",
              description:
                error.response?.data?.error?.message || error.message,
              showPopUp: true,
              hideCancel: true,
            });
          } else {
            dispatch(resetAuthentication());
          }

          console.error(error);
          if (!onlyForm?.id && !stay) {
            setAddNew(false);
          }
        }
      }
    };
    const __formData = { ...__formData_, ...relatedFields };
    const _formData = __formData;
    const editValues = getDifferingValues(editFields, _formData, false);
    const currentRole = getCookie("_r");
    const adminRole = process.env.REACT_APP_ADMIN_ROLE;

    if (
      editValues.status != null &&
      editValues.status !== "Draft" &&
      currentRole !== adminRole &&
      window.location.href.includes("/reservations")
    ) {
      setpopupData({
        title: "Save changes",
        description: (
          <div>
            You have selected status change to: {editValues.status}.
            <br />
            This action is{" "}
            <span className="text-red-500 font-bold">IRREVERSIBLE</span>. Are
            you sure you want to continue?
          </div>
        ),
        takeActionText: "Okay",
        takeActionFun: async () => {
          setIsSaving(true);
          return await handleSubmitLogic();
          // setIsSaving(false);
        },
        showPopUp: true,
      });
    } else {
      setIsSaving(true);
      return await handleSubmitLogic();
      // setIsSaving(false);
    }
  };

  const onPopUpSubmit = async (data, hasFiles, concatData, relatedPropName) => {
    const temp = [...editFields];
    const usingFieldIndex = temp?.findIndex((x) => x.name === relatedPropName);
    let temoToAddData;
    if (usingFieldIndex !== -1) {
      if (Array.isArray(temp[usingFieldIndex].checkWithFiles)) {
        //Cecking for files
        for (const cf of temp[usingFieldIndex].checkWithFiles) {
          if (cf.param) {
            if (data[cf.param]) {
              let contactToSend = data[cf.param];
              //Check if it has files

              //check if RelatedCard file params exist
              const relatedCardFileParams = getObjectParamsWithSubstring(
                data,
                `${cf.param}_`,
                true
              );

              if (hasFileInput(relatedCardFileParams)) {
                contactToSend = { ...contactToSend, ...relatedCardFileParams };
              }
              //#anchor
              if (isNaN(parseInt(contactToSend.id))) {
                const dataToSend = contactToSend;
                if (cf.apiUrlRoute) {
                  const response = await axios
                    .post(
                      config.apiUrl + "/api/" + cf.apiUrlRoute + "/add",
                      dataToSend,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    )
                    .catch((e) => {
                      console.log(e.message);
                      setpopupData({
                        isError: true,
                        title: "An Error Occured",
                        description:
                          e.response?.data?.error?.message || e.message,
                        showPopUp: true,
                        hideCancel: true,
                      });
                    });

                  if (response?.headers?.authorization) {
                    if (
                      `Bearer ${getCookie("_AT")}` !==
                      response.headers.authorization
                    ) {
                      setCookie(
                        "_AT",
                        response.headers.authorization.split(" ")[1]
                      );
                    }
                  }
                  if (response?.data) {
                    let filesToUpload = extractFiles(dataToSend);

                    if (
                      Array.isArray(filesToUpload) &&
                      filesToUpload.length > 0
                    ) {
                      for (const fileToUpload of filesToUpload) {
                        const fileToUploadValue = fileToUpload.value;
                        const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                        const totalChunks = Math.ceil(
                          fileToUploadValue.size / chunkSize
                        );
                        const chunkProgress = 100 / totalChunks;
                        let chunkNumber = 0;
                        let start = 0;
                        let end = 0;
                        setpopupData({
                          title: "Uploading",
                          description: fileToUploadValue.name,
                          showPopUp: true,
                          hideCancel: true,
                          hideMainButton: true,
                          showLoading: true,
                          progressValue: 0,
                        });

                        const uploadNextChunk = async () => {
                          if (end <= fileToUploadValue.size) {
                            start = end;
                            end = start + chunkSize;
                            const chunk = fileToUploadValue.slice(start, end);
                            const fd = new FormData();
                            fd.append("file", chunk);
                            fd.append("chunkNumber", chunkNumber);
                            fd.append("totalChunks", totalChunks);
                            fd.append("originalname", fileToUploadValue.name);
                            fd.append("type", fileToUploadValue.type);
                            fd.append("size", fileToUploadValue.size);
                            fd.append("param", fileToUpload.param || "");
                            fd.append("isMulti", fileToUpload.isMulti || false);
                            const ufResp = await axios.post(
                              config.apiUrl +
                              "/api/" +
                              cf.apiUrlRoute +
                              "/upload/" +
                              response.data?.id,
                              fd,
                              {
                                headers: {
                                  "Content-Type": "multipart/form-data",
                                  Authorization: `Bearer ${getCookie("_AT")}`,
                                },
                              }
                            );
                            setpopupData({
                              title: "Uploading",
                              description: fileToUploadValue.name,
                              showPopUp: true,
                              hideCancel: true,
                              hideMainButton: true,
                              showLoading: true,
                              progressValue: Number(
                                (chunkNumber + 1) * chunkProgress
                              ),
                            });
                            chunkNumber++;

                            await uploadNextChunk();
                          }
                        };

                        await uploadNextChunk();
                      }
                    }

                    setpopupData({
                      showPopUp: false,
                    });

                    temoToAddData = {
                      [cf.param]: response.data,
                    };
                  }
                }
              }
            }
          }
        }
      }
    }

    if (hasFileInput(data) && usingFieldIndex !== -1) {
      const apiRoute = temp[usingFieldIndex].apiUrl;
      const parentParam = temp[usingFieldIndex].parentParam;
      if (concatData.id && temp[usingFieldIndex].apiUrl) {
        const editValues = getDifferingValues(temp, concatData, false);
        const response = await axios
          .put(
            config.apiUrl + "/api/" + apiRoute + "/" + concatData.id,
            editValues,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("_AT")}`,
              },
            }
          )
          .catch((e) => {
            console.log(e.message);
            setpopupData({
              isError: true,
              title: "An Error Occured",
              description: e.response?.data?.error?.message || e.message,
              showPopUp: true,
              hideCancel: true,
            });
          });

        if (response?.headers?.authorization) {
          if (`Bearer ${getCookie("_AT")}` !== response.headers.authorization) {
            setCookie("_AT", response.headers.authorization.split(" ")[1]);
          }
        }
        if (response?.data) {
          let filesToUpload = extractFiles(data);

          if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
            for (const fileToUpload of filesToUpload) {
              const fileToUploadValue = fileToUpload.value;
              const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
              const totalChunks = Math.ceil(fileToUploadValue.size / chunkSize);
              const chunkProgress = 100 / totalChunks;
              let chunkNumber = 0;
              let start = 0;
              let end = 0;
              setpopupData({
                title: "Uploading",
                description: fileToUploadValue.name,
                showPopUp: true,
                hideCancel: true,
                hideMainButton: true,
                showLoading: true,
                progressValue: 0,
              });

              const uploadNextChunk = async () => {
                if (end <= fileToUploadValue.size) {
                  start = end;
                  end = start + chunkSize;
                  const chunk = fileToUploadValue.slice(start, end);
                  const fd = new FormData();
                  fd.append("file", chunk);
                  fd.append("chunkNumber", chunkNumber);
                  fd.append("totalChunks", totalChunks);
                  fd.append("originalname", fileToUploadValue.name);
                  fd.append("type", fileToUploadValue.type);
                  fd.append("size", fileToUploadValue.size);
                  fd.append("param", fileToUpload.param || "");
                  fd.append("isMulti", fileToUpload.isMulti || false);
                  const ufResp = await axios.post(
                    config.apiUrl +
                    "/api/" +
                    apiRoute +
                    "/upload/" +
                    response.data?.id,
                    fd,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${getCookie("_AT")}`,
                      },
                    }
                  );
                  setpopupData({
                    title: "Uploading",
                    description: fileToUploadValue.name,
                    showPopUp: true,
                    hideCancel: true,
                    hideMainButton: true,
                    showLoading: true,
                    progressValue: Number((chunkNumber + 1) * chunkProgress),
                  });
                  chunkNumber++;

                  await uploadNextChunk();
                }
              };

              await uploadNextChunk();
            }
          }

          setpopupData({
            showPopUp: false,
          });

          //temoToAddData = response.data;
        }
      } else if (apiRoute && parentParam) {
        const dataToSend = Object.assign({}, concatData, data);

        // for damages in reservation page
        // if (parentParam === "vehicle") {
        //   const vehicleId = findDataInFields(editFields, "vehicle.id");
        //   if (vehicleId == null || vehicleId.trim() === "") {
        //     dataToSend[parentParam] = editId;
        //   } else {
        //     dataToSend[parentParam] = findDataInFields(
        //       editFields,
        //       "vehicle.id"
        //     );
        //   }
        // } else {
        //   dataToSend[parentParam] = editId;
        // }
        dataToSend[parentParam] = editId;

        const response = await axios
          .post(config.apiUrl + "/api/" + apiRoute + "/add", dataToSend, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${getCookie("_AT")}`,
            },
          })
          .catch((e) => {
            console.log(e.message);
            setpopupData({
              isError: true,
              title: "An Error Occured",
              description: e.response?.data?.error?.message || e.message,
              showPopUp: true,
              hideCancel: true,
            });
          });

        if (response?.headers?.authorization) {
          if (`Bearer ${getCookie("_AT")}` !== response.headers.authorization) {
            setCookie("_AT", response.headers.authorization.split(" ")[1]);
          }
        }
        if (response?.data) {
          let filesToUpload = extractFiles(dataToSend);

          if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
            for (const fileToUpload of filesToUpload) {
              const fileToUploadValue = fileToUpload.value;
              const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
              const totalChunks = Math.ceil(fileToUploadValue.size / chunkSize);
              const chunkProgress = 100 / totalChunks;
              let chunkNumber = 0;
              let start = 0;
              let end = 0;
              setpopupData({
                title: "Uploading",
                description: fileToUploadValue.name,
                showPopUp: true,
                hideCancel: true,
                hideMainButton: true,
                showLoading: true,
                progressValue: 0,
              });

              const uploadNextChunk = async () => {
                if (end <= fileToUploadValue.size) {
                  start = end;
                  end = start + chunkSize;
                  const chunk = fileToUploadValue.slice(start, end);
                  const fd = new FormData();
                  fd.append("file", chunk);
                  fd.append("chunkNumber", chunkNumber);
                  fd.append("totalChunks", totalChunks);
                  fd.append("originalname", fileToUploadValue.name);
                  fd.append("type", fileToUploadValue.type);
                  fd.append("size", fileToUploadValue.size);
                  fd.append("param", fileToUpload.param || "");
                  fd.append("isMulti", fileToUpload.isMulti || false);
                  const ufResp = await axios.post(
                    config.apiUrl +
                    "/api/" +
                    apiRoute +
                    "/upload/" +
                    response.data?.id,
                    fd,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${getCookie("_AT")}`,
                      },
                    }
                  );
                  setpopupData({
                    title: "Uploading",
                    description: fileToUploadValue.name,
                    showPopUp: true,
                    hideCancel: true,
                    hideMainButton: true,
                    showLoading: true,
                    progressValue: Number((chunkNumber + 1) * chunkProgress),
                  });
                  chunkNumber++;

                  await uploadNextChunk();
                }
              };

              await uploadNextChunk();
            }
          }

          setpopupData({
            showPopUp: false,
          });

          temoToAddData = Object.assign({}, response.data, data);
        }
      }
    }

    const toAddData = temoToAddData
      ? temoToAddData
      : Object.assign({}, concatData, data);

    if (usingFieldIndex !== -1) {
      if (temp[usingFieldIndex].addBarier?.name) {
        const barier = extractFromObject(
          toAddData,
          temp[usingFieldIndex].addBarier.name
        );

        if (Array.isArray(temp[usingFieldIndex].defaultValue)) {
          for (const listItem of temp[usingFieldIndex].defaultValue) {
            let currentBarier = extractFromObject(
              listItem,
              temp[usingFieldIndex].addBarier.name
            );
            if (currentBarier == barier) {
              toAddData.id = listItem.id;
              toAddData.tempid = listItem.tempid;
            }
          }
        }
      }
    }

    toAddData.new = toAddData.id ? false : true;
    toAddData.changed = true;

    if (relatedFields[relatedPropName]) {
      let temp = { ...relatedFields };
      let oldRelated = [...temp[relatedPropName]] ?? [];
      if (toAddData.new) {
        if (toAddData.tempid) {
          if (Array.isArray(oldRelated)) {
            const indexToEdit = oldRelated.findIndex(
              (x) => x.tempid == toAddData.tempid
            );

            if (indexToEdit !== -1) {
              // If an object with the same id is found, replace it with toAddData
              if (toAddData.delete) {
                //Delete from array
                oldRelated.splice(indexToEdit, 1);
              } else {
                oldRelated[indexToEdit] = toAddData;
              }
            } else {
              // If no object with the same id is found, add toAddData to the array
              oldRelated.push(toAddData);
            }
          }
        } else {
          // If toAddData has no id, simply add it to the array
          if (Array.isArray(oldRelated)) {
            toAddData.tempid =
              (oldRelated.reduce((acc, value) => {
                return (acc = acc > value.tempid ? acc : value.tempid);
              }, 0) || 0) + 1;
            oldRelated.push(toAddData);
          }
        }
      } else {
        if (toAddData.id) {
          const indexToEdit = oldRelated.findIndex((x) => x.id == toAddData.id);

          if (indexToEdit !== -1) {
            // If an object with the same id is found, replace it with toAddData
            oldRelated[indexToEdit] = toAddData;
          } else {
            // If no object with the same id is found, add toAddData to the array
            oldRelated.push(toAddData);
          }
        } else {
          // If toAddData has no id, simply add it to the array
          toAddData.tempid = oldRelated.length + 1;
          oldRelated.push(toAddData);
        }
      }
      temp[relatedPropName] = [...oldRelated];

      dispatch(updaterelatedFields(temp));
    } else {
      if (toAddData.new) {
        toAddData.tempid = 1;
      }
      const temp = { ...relatedFields, [relatedPropName]: [toAddData] };
      dispatch(updaterelatedFields(temp));
    }

    const tempfieldIndex = temp?.findIndex((x) => x.name === relatedPropName);

    if (tempfieldIndex && tempfieldIndex !== -1) {
      let tempDV = temp[tempfieldIndex].defaultValue
        ? temp[tempfieldIndex].defaultValue
        : [];

      if (Array.isArray(tempDV)) {
        let arrToAdd = [...tempDV]; // Clone the original array

        if (toAddData.id) {
          const indexToEdit = tempDV.findIndex((x) => x.id == toAddData.id);

          if (indexToEdit !== -1) {
            // If an object with the same id is found, replace it with toAddData
            arrToAdd[indexToEdit] = toAddData;
          } else {
            // If no object with the same id is found, add toAddData to the array
            arrToAdd.push(toAddData);
          }
        } else if (toAddData.tempid) {
          const indexToEdit = tempDV.findIndex(
            (x) => x.tempid == toAddData.tempid
          );

          if (indexToEdit !== -1) {
            // If an object with the same id is found, replace it with toAddData
            if (toAddData.delete) {
              //Delete from array
              arrToAdd.splice(indexToEdit, 1);
            } else {
              arrToAdd[indexToEdit] = toAddData;
            }
          } else {
            // If no object with the same id is found, add toAddData to the array
            arrToAdd.push(toAddData);
          }
        } else {
          // If toAddData has no id, simply add it to the array
          arrToAdd.push(toAddData);
        }

        // Update the defaultValue property to a new default value
        const updatedTempfield = {
          ...temp[tempfieldIndex],
          defaultValue: arrToAdd,
          changed: true,
        };

        if (updatedTempfield.affectsOn) {
          if (
            updatedTempfield.affectsOn.name &&
            updatedTempfield.affectsOn.subname &&
            updatedTempfield.affectsOn.operation
          ) {
            const affectedFieldIndex = temp.findIndex(
              (x) => x.name === updatedTempfield.affectsOn.name
            );
            let condition = "";
            if (
              updatedTempfield.affectsOn.condition &&
              updatedTempfield.affectsOn.compareWith
            ) {
              condition = findDataInObject(
                toAddData,
                updatedTempfield.affectsOn.compareWith
              );
            }

            if (
              affectedFieldIndex !== -1 &&
              toAddData[updatedTempfield.affectsOn.subname] &&
              (updatedTempfield.affectsOn.condition
                ? updatedTempfield.affectsOn.condition === condition
                : true)
            ) {
              let value =
                parseFloat(temp[affectedFieldIndex].defaultValue) || 0;
              switch (updatedTempfield.affectsOn.operation) {
                case "subtract":
                  value =
                    value -
                    (parseFloat(
                      toAddData[updatedTempfield.affectsOn.subname]
                    ) || 0);
                  break;
                case "add":
                  value =
                    value +
                    (parseFloat(
                      toAddData[updatedTempfield.affectsOn.subname]
                    ) || 0);
                  break;
                case "increment":
                  value++;
                  break;
                default:
                  break;
              }
              const updatedAffectedValue = {
                ...temp[affectedFieldIndex],
                defaultValue: value,
              };
              dispatch(
                updateShowFieldsByIndex({
                  index: affectedFieldIndex,
                  toChange: updatedAffectedValue,
                })
              );
            }
          }
        }

        if (updatedTempfield.affectsOn2) {
          if (
            updatedTempfield.affectsOn2.name &&
            updatedTempfield.affectsOn2.subname &&
            updatedTempfield.affectsOn2.operation
          ) {
            const affectedFieldIndex = temp.findIndex(
              (x) => x.name === updatedTempfield.affectsOn2.name
            );
            let condition = "";
            if (
              updatedTempfield.affectsOn2.condition &&
              updatedTempfield.affectsOn2.compareWith
            ) {
              condition = findDataInObject(
                toAddData,
                updatedTempfield.affectsOn2.compareWith
              );
            }

            if (
              affectedFieldIndex !== -1 &&
              toAddData[updatedTempfield.affectsOn2.subname] &&
              (updatedTempfield.affectsOn2.condition
                ? updatedTempfield.affectsOn2.condition === condition
                : true)
            ) {
              let value =
                parseFloat(temp[affectedFieldIndex].defaultValue) || 0;
              switch (updatedTempfield.affectsOn2.operation) {
                case "subtract":
                  value =
                    value -
                    (parseFloat(
                      toAddData[updatedTempfield.affectsOn2.subname]
                    ) || 0);
                  break;
                case "add":
                  value =
                    value +
                    (parseFloat(
                      toAddData[updatedTempfield.affectsOn2.subname]
                    ) || 0);
                  break;
                default:
                  break;
              }
              const updatedAffectedValue = {
                ...temp[affectedFieldIndex],
                defaultValue: value,
              };
              dispatch(
                updateShowFieldsByIndex({
                  index: affectedFieldIndex,
                  toChange: updatedAffectedValue,
                })
              );
            }
          }
        }

        if (updatedTempfield.affectList) {
          if (updatedTempfield.affectList.name) {
            const affectedListIndex = temp.findIndex(
              (x) => x.name === updatedTempfield.affectList.name
            );
            if (
              Array.isArray(updatedTempfield.affectList.affectsBy) &&
              affectedListIndex !== -1
            ) {
              let oldDefaultValue = temp[affectedListIndex].defaultValue
                ? [...temp[affectedListIndex].defaultValue]
                : [];

              for (const ab of updatedTempfield.affectList.affectsBy) {
                if (ab.rowAffected) {
                  if (ab.rowAffected.param) {
                    if (
                      ab.rowAffected.lazyload &&
                      ab.rowAffected.lazyloadurl &&
                      ab.rowAffected.lazyloadParam
                    ) {
                      await axios
                        .get(
                          `${config.apiUrl}/api/${ab.rowAffected.lazyloadurl}`,
                          {
                            headers: {
                              Authorization: `Bearer ${getCookie("_AT")}`,
                            },
                          }
                        )
                        .then((res) => {
                          if (res.headers?.authorization) {
                            if (
                              `Bearer ${getCookie("_AT")}` !==
                              res.headers.authorization
                            ) {
                              setCookie(
                                "_AT",
                                res.headers.authorization.split(" ")[1]
                              );
                            }
                          }
                          if (Array.isArray(res?.data)) {
                            if (res.data.length > 0) {
                              const searchWith = findDataInObject(
                                res.data[0],
                                ab.rowAffected.lazyloadParam
                              );
                              let toChangeIndex = -1;
                              if (oldDefaultValue.length > 0) {
                                toChangeIndex = oldDefaultValue.findIndex((x) =>
                                  ab.rowAffected.subparam
                                    ? x[ab.rowAffected.param][
                                    ab.rowAffected.subparam
                                    ] == searchWith
                                    : x[ab.rowAffected.param] == searchWith
                                );
                              }
                              if (toChangeIndex !== -1 && ab.paramAffected) {
                                switch (ab.operation) {
                                  case "listcount":
                                    const listCount = Array.isArray(
                                      updatedTempfield.defaultValue
                                    )
                                      ? updatedTempfield.defaultValue.filter(
                                        (x) => x.delete !== true
                                      ).length
                                      : 0;
                                    if (listCount > 0) {
                                      const temp = {
                                        ...oldDefaultValue[toChangeIndex],
                                      };
                                      temp[ab.paramAffected] = listCount;
                                      temp.changed = true;
                                      temp.delete = false;
                                      oldDefaultValue[toChangeIndex] = temp;
                                    } else if (listCount === 0) {
                                      const temp = {
                                        ...oldDefaultValue[toChangeIndex],
                                      };
                                      temp[ab.paramAffected] = 0;
                                      temp.delete = true;
                                      oldDefaultValue[toChangeIndex] = temp;
                                    }
                                    break;

                                  default:
                                    break;
                                }
                              } else {
                                //Add it lo list
                                if (
                                  Array.isArray(oldDefaultValue) &&
                                  ab.paramAffected
                                ) {
                                  const listCount = Array.isArray(
                                    updatedTempfield.defaultValue
                                  )
                                    ? updatedTempfield.defaultValue.filter(
                                      (x) => x.delete !== true
                                    ).length
                                    : 0;
                                  const tempObj = {
                                    [ab.rowAffected.param]:
                                      res.data[0][
                                      ab.rowAffected.lazyloadParam.split(
                                        "."
                                      )[0]
                                      ],
                                    [ab.paramAffected]: listCount,
                                    new: true,
                                    changed: true,
                                    delete: false,
                                    tempid: oldDefaultValue.length + 1,
                                  };
                                  oldDefaultValue.push(tempObj);
                                }
                              }
                            }
                          }
                        })
                        .catch((e) => console.log(e.message));
                    } else if (ab.rowAffected.value) {
                      const searchWith = ab.rowAffected.value;
                      let toChangeIndex = -1;
                      if (oldDefaultValue.length > 0) {
                        toChangeIndex = oldDefaultValue.findIndex((x) =>
                          ab.rowAffected.subparam
                            ? x[ab.rowAffected.param][
                            ab.rowAffected.subparam
                            ] == searchWith
                            : x[ab.rowAffected.param] == searchWith
                        );
                      }
                      if (toChangeIndex !== -1 && ab.paramAffected) {
                        switch (ab.operation) {
                          case "listcount":
                            const listCount = Array.isArray(
                              updatedTempfield.defaultValue
                            )
                              ? updatedTempfield.defaultValue.filter(
                                (x) => x.delete !== true
                              ).length
                              : 0;

                            if (listCount > 0) {
                              const temp = {
                                ...oldDefaultValue[toChangeIndex],
                              };
                              temp[ab.paramAffected] = listCount;
                              temp.changed = true;
                              temp.delete = false;
                              oldDefaultValue[toChangeIndex] = temp;
                            } else if (listCount === 0) {
                              const temp = {
                                ...oldDefaultValue[toChangeIndex],
                              };
                              temp[ab.paramAffected] = 0;
                              temp.delete = true;
                              oldDefaultValue[toChangeIndex] = temp;
                            }
                            break;

                          default:
                            break;
                        }
                      }
                    }
                  }
                }
              }

              let changedDefault = oldDefaultValue.filter(
                (x) => x.changed === true
              );
              if (changedDefault.length > 0) {
                //const tempRF = { ...relatedFields, [updatedTempfield.affectList.name] : oldDefaultValue };
                dispatch(
                  updateRelatedFieldsByParam({
                    paramName: updatedTempfield.affectList.name,
                    value: oldDefaultValue,
                  })
                );
              }

              dispatch(updaterelatedFields);

              dispatch(
                updateShowFieldsByIndex({
                  index: affectedListIndex,
                  toChange: {
                    ...temp[affectedListIndex],
                    defaultValue: oldDefaultValue,
                    changed: true,
                  },
                })
              );
            }
          }
        }

        dispatch(
          updateShowFieldsByIndex({
            index: tempfieldIndex,
            toChange: updatedTempfield,
          })
        );
        resetPopUp();
      }
    }
  };

  const handleRelatedData = (_data, name, _action, subname) => {
    let action = _action;
    let data = _data;
    const field = editFields?.find((x) => x.name === name);

    const errorCheck =
      field &&
      field.formOptions &&
      Array.isArray(field.formOptions.fields) &&
      field.formOptions.fields.length > 0;
    const clickedDefaultValue =
      data && (data.id || data.tempid) && errorCheck && field.defaultValue
        ? field.defaultValue.find((x) =>
          x.id ? x.id == data.id : x.tempid ? x.tempid == data.tempid : false
        )
        : null;

    if (action && errorCheck) {
      const toUpdate = clickedDefaultValue
        ? addDefaultValuesToFields(
          field.formOptions.fields,
          clickedDefaultValue
        )
        : field.formOptions.fields;

      switch (action) {
        case "view":
          setpopupData({
            title: "View",
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: null,
            formConcatData: {},
            propName: name,
            disabledForm: true,
          });
          break;
        case "edit":
          setpopupData({
            title: "Edit",
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: onPopUpSubmit,
            formConcatData: clickedDefaultValue,
            propName: subname ? subname : name,
            disabledForm: false,
          });
          break;
        case "update":
          onPopUpSubmit(data, false, clickedDefaultValue, name);
          break;
        case "add":
          setpopupData({
            title: "New",
            overflow: false,
            expand: true,
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: onPopUpSubmit,
            formConcatData: data
              ? Object.assign({}, data, clickedDefaultValue ?? {})
              : clickedDefaultValue ?? {},
            propName: subname ? subname : name,
            disabledForm: false,
          });
          break;
        default:
          break;
      }
    } else {
      if (errorCheck) {
        setpopupData({
          title: field.formOptions.label,
          formOptions: field.formOptions.fields,
          showPopUp: true,
          formSubmit: onPopUpSubmit,
          formConcatData: data,
          propName: name,
          disabledForm: false,
        });
      }
    }
  };

  const onPopUpSubmitSingleCreateData = async (
    data,
    hasFiles,
    concatData,
    relatedPropName
  ) => {
    resetPopUp();
    const temp = [...editFields];
    const usingFieldIndex = temp?.findIndex((x) => x.name === relatedPropName);
    let temoToAddData;
    if (usingFieldIndex !== -1) {
      if (data) {
        //Cecking for files
        if (temp[usingFieldIndex].addNew?.apiUrlRoute) {
          const dataToSend = data; //new FormData();
          setpopupData({
            title: "Saving data...",
            showPopUp: true,
            hideCancel: true,
            hideMainButton: true,
            showLoading: true,
          });

          const response = await axios
            .post(
              config.apiUrl +
              "/api/" +
              temp[usingFieldIndex].addNew.apiUrlRoute +
              "/add",
              dataToSend,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getCookie("_AT")}`,
                },
              }
            )
            .catch((e) => {
              console.log(e.message);
              setpopupData({
                isError: true,
                title: "Error submitting form",
                description: e.response?.data?.error?.message || e.message,
                showPopUp: true,
                hideCancel: true,
              });
            });
          if (response?.headers?.authorization) {
            if (
              `Bearer ${getCookie("_AT")}` !== response.headers.authorization
            ) {
              setCookie("_AT", response.headers.authorization.split(" ")[1]);
            }
          }
          if (response?.data) {
            let filesToUpload = extractFiles(dataToSend, editFields);

            if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
              for (const fileToUpload of filesToUpload) {
                const fileToUploadValue = fileToUpload.value;
                const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                const totalChunks = Math.ceil(
                  fileToUploadValue.size / chunkSize
                );
                const chunkProgress = 100 / totalChunks;
                let chunkNumber = 0;
                let start = 0;
                let end = 0;
                setpopupData({
                  title: "Uploading",
                  description: fileToUploadValue.name,
                  showPopUp: true,
                  hideCancel: true,
                  hideMainButton: true,
                  showLoading: true,
                  progressValue: 0,
                });

                const uploadNextChunk = async () => {
                  if (end <= fileToUploadValue.size) {
                    start = end;
                    end = start + chunkSize;
                    const chunk = fileToUploadValue.slice(start, end);
                    const fd = new FormData();
                    fd.append("file", chunk);
                    fd.append("chunkNumber", chunkNumber);
                    fd.append("totalChunks", totalChunks);
                    fd.append("originalname", fileToUploadValue.name);
                    fd.append("type", fileToUploadValue.type);
                    fd.append("size", fileToUploadValue.size);
                    fd.append("param", fileToUpload.param || "");
                    fd.append("isMulti", fileToUpload.isMulti || false);
                    const ufResp = await axios.post(
                      config.apiUrl +
                      "/api/" +
                      temp[usingFieldIndex].addNew.apiUrlRoute +
                      "/upload/" +
                      response.data?.id,
                      fd,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    );
                    setpopupData({
                      title: "Uploading",
                      description: fileToUploadValue.name,
                      showPopUp: true,
                      hideCancel: true,
                      hideMainButton: true,
                      showLoading: true,
                      progressValue: Number((chunkNumber + 1) * chunkProgress),
                    });
                    chunkNumber++;

                    await uploadNextChunk();
                  }
                };

                await uploadNextChunk();
              }
            }

            setpopupData({
              showPopUp: false,
            });

            temoToAddData = {
              id: response.data.id,
              name: response.data.name,
            };
            let temp2 = { ...relatedFields };
            temp2[relatedPropName] = temoToAddData.id;
            dispatch(updaterelatedFields(temp2));
            // Update the defaultValue property to a new default value
            let updatedTempfield = {
              ...temp[usingFieldIndex],
              defaultValue: temoToAddData.id,
              changed: true,
            };

            if (Array.isArray(updatedTempfield.data)) {
              const tempData = [...updatedTempfield.data];
              tempData.push(temoToAddData);
              updatedTempfield.data = tempData;
            } else {
              updatedTempfield.data = [temoToAddData];
            }
            dispatch(
              updateShowFieldsByIndex({
                index: usingFieldIndex,
                toChange: updatedTempfield,
              })
            );
          }
        }
      }
    }
  };

  const handleSingleCreateData = (name) => {
    const field = editFields?.find((x) => x.name === name);

    const errorCheck =
      field &&
      field.addNew?.formOptions &&
      Array.isArray(field.addNew?.formOptions?.fields) &&
      field.addNew?.formOptions?.fields.length > 0;
    if (errorCheck) {
      setpopupData({
        title: field.addNew.formOptions.label || "New",
        formOptions: field.addNew.formOptions.fields,
        showPopUp: true,
        formSubmit: onPopUpSubmitSingleCreateData,
        formConcatData: {},
        propName: name,
        disabledForm: false,
      });
    }
  };

  const onFormCancel = async () => {
    dispatch(updatenavPopup({ backClicked: true }));
  };
  const finalizeCancel = () => {
    getData();
    setEdit(false);
    setAddNew(false);
    dispatch(resetrelatedFields());
    dispatch(emptyShowFields());
    dispatch(updatenavPopup({ trigger: false, backClicked: false }));
    dispatch(
      updatepageHeader({
        secondaryButton: false,
        secondaryButtonText: null,
        secondaryButtonFunction: null,
      })
    );
    dispatch(
      updatepageHeader({
        addButton: false,
        buttonText: null,
        buttonFunction: null,
      })
    );
    dispatch(setShowPopupFalse());
  };
  const disableParams = (name, value) => {
    const checkField = editFields.find((x) => x.name === name);
    if (checkField?.disableCondition) {
      if (
        Array.isArray(checkField.disableCondition) &&
        checkField.disableCondition.length > 0
      ) {
        for (const condition of checkField.disableCondition) {
          if (value === condition.value) {
            if (
              Array.isArray(condition.params) &&
              condition.params.length > 0
            ) {
              dispatch(
                addDisableToParams({
                  paramName: "name",
                  values: condition.params,
                  showValues: condition.showparams,
                })
              );
            }
            break;
          }
        }
      }
    }
  };
  useEffect(() => {
    //showPopup

    if (addNew === true) {
      if (navPopup.backClicked) {
        if (navPopup.showPopup) {
          setpopupData({
            isError: true,
            title: "Are you sure you want to exit?",
            description: "You might lose unsaved changes.",
            showPopUp: true,
            takeActionText: "Yes",
            hidePopup: () => {
              dispatch(
                updatenavPopup({
                  showPopup: false,
                  trigger: false,
                  backClicked: false,
                })
              );
              setpopupData({});
            },
            takeActionFun: () => {
              dispatch(
                updatenavPopup({
                  showPopup: false,
                  trigger: false,
                  backClicked: false,
                })
              );
              setAddNew(false);
            },
          });
        } else {
          setAddNew(false);
          dispatch(
            updatenavPopup({
              showPopup: false,
              trigger: false,
              backClicked: false,
            })
          );
          setpopupData({});
        }
      }
    }
  }, [navPopup]);

  return (
    <div>
      {!addNew ? (
        loading ? (
          <div className="flex h-full justify-center align-center">
            <PropagateLoader color="#0167ff" />
          </div>
        ) : enhancedTable ? (
          <EnhancedDynamicList
            tableNameInDb={tableNameInDb}
            apiRoute={apiRoute}
            columns={columns}
            data={data}
            deleteClicked={deleteClicked}
            duplicateClicked={duplicateClicked}
            deleteRoles={deleteRoles}
            editRoles={editRoles}
            bulkActions={bulkActions}
            callPopUp={callPopUp}
            hasImport={hasImport}
            importConfig={importConfig}
          />
        ) : (
          <DynamicList
            tableNameInDb={tableNameInDb}
            apiRoute={apiRoute}
            columns={columns}
            data={data}
            deleteClicked={deleteClicked}
            duplicateClicked={duplicateClicked}
            deleteRoles={deleteRoles}
            editRoles={editRoles}
            bulkActions={bulkActions}
            callPopUp={callPopUp}
            hasImport={hasImport}
            importConfig={importConfig}
          />
        )
      ) : loading ? (
        <div className="flex h-full justify-center align-center">
          <PropagateLoader color="#0167ff" />
        </div>
      ) : (
        <ReusableForm
          formType={"add"}
          fields={editFields}
          isSaving={isSaving}
          setIsSaving={setIsSaving}
          onSubmit={handleSubmit}
          onCancel={onFormCancel}
          tabsData={
            edit && editId ? tabsData : tabsData?.filter((x) => !x.hideNew)
          }
          handleRelatedData={handleRelatedData}
          handleSingleCreateData={handleSingleCreateData}
          updateShowFields={formDataChanged}
          id={editId}
          onlyForm={onlyForm}
          callPopUp={callPopUp}
          hideSubmitActions={true}
          headerSaveBotton={true}
          disableConditionsFunction={disableParams}
          reservationCode={reservationCode}
        />
      )}

      <PopUp
        autoClose={popupData.autoClose}
        isError={popupData.isError}
        title={popupData.title}
        description={popupData.description}
        formOptions={popupData.formOptions}
        takeActionText={popupData.takeActionText}
        takeActionFun={popupData.takeActionFun}
        showPopUp={popupData.showPopUp}
        hidePopUp={resetPopUp}
        formSubmit={popupData.formSubmit}
        formConcatData={popupData.formConcatData}
        propName={popupData.propName}
        disabledForm={popupData.disabledForm}
        hideCancel={popupData.hideCancel}
        hideMainButton={popupData.hideMainButton}
        showLoading={popupData.hideMainButton}
        progressValue={popupData.progressValue}
        overflow={popupData.overflow}
        expand={popupData.expand}
      >
        {popupData.children}
      </PopUp>
    </div>
  );
};

export default ListFormTemplate;
